<!--布局文件-->
<template>
    <div class="Layout">
        <slot name="header">
            <Header/>
        </slot>
        <slot></slot>
        <slot name="footer">
            <Footer/>
        </slot>
    </div>
</template>
<script>
	import Footer from './Footer/Index';
	import Header from './Header/Index';

	export default {
		components:{
			Footer,Header
		}
	};
</script>
<style lang="sass" scoped>
</style>
